// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    kalshiPublicGetEvents (params?: {}): Promise<Dict>;
    kalshiPublicGetEventsMultivariate (params?: {}): Promise<Dict>;
    kalshiPublicGetEventsFeeChanges (params?: {}): Promise<Dict>;
    kalshiPublicGetEventsEventTicker (params?: {}): Promise<Dict>;
    kalshiPublicGetEventsEventTickerMetadata (params?: {}): Promise<Dict>;
    kalshiPublicGetSeries (params?: {}): Promise<Dict>;
    kalshiPublicGetSeriesFeeChanges (params?: {}): Promise<Dict>;
    kalshiPublicGetSeriesSeriesTicker (params?: {}): Promise<Dict>;
    kalshiPublicGetSeriesSeriesTickerMarketsTickerCandlesticks (params?: {}): Promise<Dict>;
    kalshiPublicGetSeriesSeriesTickerEventsTickerCandlesticks (params?: {}): Promise<Dict>;
    kalshiPublicGetSeriesSeriesTickerEventsTickerForecastPercentileHistory (params?: {}): Promise<Dict>;
    kalshiPublicGetMarkets (params?: {}): Promise<Dict>;
    kalshiPublicGetMarketsTrades (params?: {}): Promise<Dict>;
    kalshiPublicGetMarketsOrderbooks (params?: {}): Promise<Dict>;
    kalshiPublicGetMarketsCandlesticks (params?: {}): Promise<Dict>;
    kalshiPublicGetMarketsTicker (params?: {}): Promise<Dict>;
    kalshiPublicGetMarketsTickerOrderbook (params?: {}): Promise<Dict>;
    kalshiPublicGetExchangeStatus (params?: {}): Promise<Dict>;
    kalshiPublicGetExchangeSchedule (params?: {}): Promise<Dict>;
    kalshiPublicGetExchangeAnnouncements (params?: {}): Promise<Dict>;
    kalshiPublicGetExchangeUserDataTimestamp (params?: {}): Promise<Dict>;
    kalshiPublicGetMilestones (params?: {}): Promise<Dict>;
    kalshiPublicGetMilestonesMilestoneId (params?: {}): Promise<Dict>;
    kalshiPublicGetStructuredTargets (params?: {}): Promise<Dict>;
    kalshiPublicGetStructuredTargetsStructuredTargetId (params?: {}): Promise<Dict>;
    kalshiPublicGetSearchFiltersBySport (params?: {}): Promise<Dict>;
    kalshiPublicGetSearchTagsByCategories (params?: {}): Promise<Dict>;
    kalshiPublicGetLiveDataBatch (params?: {}): Promise<Dict>;
    kalshiPublicGetLiveDataMilestoneMilestoneId (params?: {}): Promise<Dict>;
    kalshiPublicGetHistoricalMarkets (params?: {}): Promise<Dict>;
    kalshiPublicGetHistoricalMarketsTickerCandlesticks (params?: {}): Promise<Dict>;
    kalshiPublicGetHistoricalTrades (params?: {}): Promise<Dict>;
    kalshiPublicGetHistoricalCutoffTimestamps (params?: {}): Promise<Dict>;
    kalshiPublicGetMultivariateEventCollections (params?: {}): Promise<Dict>;
    kalshiPublicGetMultivariateEventCollectionsCollectionTicker (params?: {}): Promise<Dict>;
    kalshiPublicGetMultivariateEventCollectionsCollectionTickerLookup (params?: {}): Promise<Dict>;
    kalshiPublicGetIncentivePrograms (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioBalance (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrders (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrdersOrderId (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrdersOrderIdQueuePosition (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrdersQueuePositions (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioPositions (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioFills (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioSettlements (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioDeposits (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioWithdrawals (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrderGroups (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioOrderGroupsOrderGroupId (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioSummaryTotalRestingOrderValue (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioSubaccountsBalances (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioSubaccountsNetting (params?: {}): Promise<Dict>;
    kalshiPrivateGetPortfolioSubaccountsTransfers (params?: {}): Promise<Dict>;
    kalshiPrivateGetHistoricalFills (params?: {}): Promise<Dict>;
    kalshiPrivateGetHistoricalOrders (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioOrders (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioEventsOrders (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioOrdersBatched (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioOrdersOrderIdAmend (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioOrdersOrderIdDecrease (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioOrderGroupsCreate (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioSubaccounts (params?: {}): Promise<Dict>;
    kalshiPrivatePostPortfolioSubaccountsTransfer (params?: {}): Promise<Dict>;
    kalshiPrivatePostMultivariateEventCollectionsCollectionTicker (params?: {}): Promise<Dict>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdReset (params?: {}): Promise<Dict>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdTrigger (params?: {}): Promise<Dict>;
    kalshiPrivatePutPortfolioOrderGroupsOrderGroupIdLimit (params?: {}): Promise<Dict>;
    kalshiPrivatePutPortfolioSubaccountsNetting (params?: {}): Promise<Dict>;
    kalshiPrivatePutMultivariateEventCollectionsCollectionTickerLookup (params?: {}): Promise<Dict>;
    kalshiPrivateDeletePortfolioOrdersOrderId (params?: {}): Promise<Dict>;
    kalshiPrivateDeletePortfolioOrdersBatched (params?: {}): Promise<Dict>;
    kalshiPrivateDeletePortfolioEventsOrdersOrderId (params?: {}): Promise<Dict>;
    kalshiPrivateDeletePortfolioOrderGroupsOrderGroupId (params?: {}): Promise<Dict>;
    electionsPublicGetSearchSeries (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
